import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-text-italic",
  "use": "icon-text-italic-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-text-italic\"><defs><style>#icon-text-italic .a{fill:#fff;}</style></defs><path class=\"a\" d=\"M864,3121h-8a1,1,0,0,0,0,2h2.178l-12.728,20H842a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2h-2.179l12.728-20H864a1,1,0,0,0,0-2Z\" transform=\"translate(-841 -3121)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol